import { ReactNode, useCallback, useEffect, useState } from 'react';
import copyImg from './assets/images/copy.png';
import { QRCodeSVG } from 'qrcode.react';
import errorImg from './assets/images/error.png';
import Loading from './Loading';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import axios from 'axios';
import './App.css';
import { getExqueryDomain } from 'repos/config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';

dayjs.extend(utc);
dayjs.extend(duration);

enum STATUS {
	LOADING,
	SUCCESS,
	FAILED,
}

const PAYMENT_PENDING_STATUS = 2;
const PAYMENT_SUCCESS_STATUS = 3;
const PAYMENT_POLLING_INTERVAL = 20000;

function App() {
	const [status, setStatus] = useState<STATUS>();
	const [data, setData] = useState<EXTERNALQUERY_API.QueryInvoiceReply>();
	const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
	const [modalTitle, setModalTitle] = useState<string>();
	const [modalContent, setModalContent] = useState<ReactNode>();
	const [modalBtnText, setModalBtnText] = useState<string>();
	const [isTimeOut, setIsTimeOut] = useState<boolean>(false);
	const [countdown, setCountdown] = useState('00:00');
	const [expireTime, setExpireTime] = useState<string | undefined>();
	const getInvoiceParam = () => {
		const params = new URLSearchParams(window.location.search);
		return params.get('param');
	};
	const closeModal = () => {
		setModalIsOpen(false);
	};
	const openCopyedmodal = async () => {
		try {
			const param = getInvoiceParam();
			if (!param) {
				throw new Error('param error');
			}
			axios.put(`${getExqueryDomain()}/invoice/${param}`);
			setModalContent(
				<div className="flex">
					<img src={copyImg} alt="" />
					<div className="modalContent">Copiado com sucesso</div>
				</div>,
			);
			setModalTitle('');
			setModalBtnText('ok');
			setModalIsOpen(true);
		} catch (error) {
			throw new Error('error');
		}
	};
	const openExpiredModal = () => {
		setModalTitle('dica');
		setModalContent(`O pedido expirou. Por favor, inicie o pagamento repetidamente.`);
		setModalBtnText('confirmação');
		setModalIsOpen(true);
	};
	const loadData = useCallback(async () => {
		setStatus(STATUS.LOADING);
		try {
			const param = getInvoiceParam();
			if (!param) {
				throw new Error('param error');
			}
			const resp = await axios.get(`${getExqueryDomain()}/invoice/${param}`);
			if (resp?.data?.redirect) {
				window.location.replace(resp?.data?.redirect);
				return;
			}
			if (resp.data.status === PAYMENT_SUCCESS_STATUS && resp.data.returnUrl) {
				window.location.replace(resp.data.returnUrl);
				return;
			}
			setData(resp.data);
			if (resp.data.status !== PAYMENT_PENDING_STATUS) {
				openExpiredModal();
			}
			if (resp.data.plain) {
				setExpireTime(resp.data.expireTime);
				setIsTimeOut(false);
			} else {
				setIsTimeOut(true);
				setExpireTime(undefined);
			}
		} catch (e) {
			setStatus(STATUS.FAILED);
			return;
		}
		setStatus(STATUS.SUCCESS);
	}, []);
	useEffect(() => {
		if (expireTime) {
			// expireTime 本身是utc时间
			const targetTimeUTC = dayjs.utc(expireTime, 'YYYY-MM-DD HH:mm:ss');
			const interval = setInterval(() => {
				const nowUTC = dayjs().utc(); // 当前 UTC时间
				const diff = targetTimeUTC.diff(nowUTC);

				if (diff <= 0) {
					clearInterval(interval);
					setCountdown('00:00');
					// 重新请求接口更新状态
					loadData();
				} else {
					const duration = dayjs.duration(diff);
					const minutes = String(duration.minutes()).padStart(2, '0');
					const seconds = String(duration.seconds()).padStart(2, '0');
					setCountdown(`${minutes}:${seconds}`);
				}
			}, 1000);

			return () => clearInterval(interval);
		}
	}, [expireTime, loadData]);
	useEffect(() => {
		if (status !== STATUS.SUCCESS || isTimeOut || !expireTime) {
			return;
		}

		const interval = setInterval(async () => {
			try {
				const param = getInvoiceParam();
				if (!param) {
					return;
				}
				const resp = await axios.get(`${getExqueryDomain()}/invoice/${param}`);
				if (resp.data.status === PAYMENT_SUCCESS_STATUS && resp.data.returnUrl) {
					window.location.replace(resp.data.returnUrl);
				}
			} catch (e) {}
		}, PAYMENT_POLLING_INTERVAL);

		return () => clearInterval(interval);
	}, [expireTime, isTimeOut, status]);
	useEffect(() => {
		if (status !== undefined) {
			return;
		}
		loadData();
		return () => {};
	}, [loadData, status]);

	if (status === STATUS.LOADING) {
		return (
			<div className="Loading">
				<Loading />
			</div>
		);
	}

	if (status !== STATUS.SUCCESS) {
		return (
			<div className="Loading">
				<img src={errorImg} alt="" />
				<div className="errorText">El enlace ha caducado, reinicie el pago</div>
			</div>
		);
	}
	return (
		<section>
			<div className="main">
				<div className="title">
					<div
						className="returnImg"
						onClick={() => {
							if (data?.returnUrl) {
								window.location.href = data?.returnUrl;
							} else {
								window.history.back();
							}
						}}
					></div>
				</div>
				<div className="titleText">Use o QR Code do Pix para pagar</div>
				<div className="main-content">
					{/* <div className="description">
						Use o app de seu banco ou carteir
						a digital para escanear o código QR abaixo
					</div> */}
					{/* <div className="expireAt">{`Expiração: ${data?.expireTime}`}</div> */}
					<div className="countdown">
						Tempo de expiração: <span>{countdown}</span>
					</div>
					<div className="amount">{`R$ ${
						data?.orderAmount && (data?.orderAmount / 100).toFixed(2)
					}`}</div>
					<div className="codeBox">
						<QRCodeSVG size={182} value={data?.plain || ''} />
						<div className={`mask ${isTimeOut ? 'show' : ''}`}>Código qr expirou</div>
					</div>
				</div>
				<div className="footer">
					<CopyToClipboard
						text={data!.plain || ''}
						onCopy={() => {
							if (isTimeOut) {
								return;
							}
							openCopyedmodal();
						}}
					>
						<button className={`button ${isTimeOut ? 'disabled' : ''}`}>COPIAR CÓDIGO PIX</button>
					</CopyToClipboard>
				</div>
				<div className="tips">
					<div>
						Abra o app com sua chave PIX cadastrada, escolha Pagar com Pix e escaneie o QR Code ou
						copie e cole o código.
					</div>
					<div>
						Este código QR só pode ser pago uma vez, se você precisar pagar novamente, solicite
						novamente COPIAR CÓDIGO PIX
					</div>
				</div>
			</div>
			{modalIsOpen && (
				<div className="modal">
					<div className="mask" onClick={closeModal} />
					<div className="modal-container">
						<section className="title">{modalTitle}</section>
						<section className="content">{modalContent}</section>
						<section className="footer">
							<button onClick={closeModal}>{modalBtnText}</button>
						</section>
					</div>
				</div>
			)}
		</section>
	);
}
export default App;
